module.exports = __webpack_public_path__ + "static/media/b-sci-major-14_LR.ed73c70f.jpg";